import 'whatwg-fetch';
import { formatQueryObj, loginStateExpiress, afterLoginFailed } from '@/common/utils';
import { message } from 'antd';

const CODE_ISOK = -10000;

function responseIsOk(res) {
  if (typeof res !== 'object') return res;
  res.ret = CODE_ISOK;

  return res;
}

// 只会删除第一层，多了怕影响性能
export function removeInvalidKey(query) {
  if (typeof query === 'object' && query) {
    for (var key in query) {
      try {
        if (query[key] == null) delete query[key];
      } catch (ex) {}
    }
  }
  return query;
}

// function _fetch (request) {
//   return new Promise((resolve, reject) => {
//     const timeoutId = setTimeout(() => {
//       reject(new Error('网络异常请重试'))
//     }, 15000)

//     request.then(res => {
//       clearTimeout(timeoutId)
//       resolve(res)
//     }).catch(ex => {
//       clearTimeout(timeoutId)
//       reject(ex)
//     })
//   })
// }

export async function fetcher(ctx) {
  const { api, options: _options } = ctx;
  const options = { ..._options };
  const { query } = options;
  let { method = 'GET' } = options;

  removeInvalidKey(query);

  method = method.toUpperCase();

  options.method = method;
  options.mode = 'cors';
  options.credentials = 'include';

  const headers = {};

  // contentType的设置只和请求体有关
  if (options.body instanceof window.FormData) {
    // content-type: form-data; boundary=xxxxx
    // 上面的boundary是浏览器生成的，不要自己指定content-type
    // 自己指定content-type会导致浏览器不帮你生成boundary
    // 然后body中携带的数据就没了
  } else {
    if (options.body instanceof Object) {
      headers['Content-Type'] = 'application/json; charset=utf-8';
      options.body = JSON.stringify(options.body);
    } else {
      headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8';
    }
  }

  options.headers = { ...headers, ...(options.headers || {}) };

  const tmpQuery = formatQueryObj(query);

  const url = tmpQuery ? api + (api.indexOf('?') !== -1 ? '&' : '?' + tmpQuery) : api;

  let fetchIns;
  try {
    fetchIns = await window.fetch(url, options);
  } catch (ex) {
    console.error(ex);
    throw new Error('网络错误请重试');
  }

  if (fetchIns.status !== 200 || !fetchIns.ok) {
    throw new Error('网络错误请重试');
  }

  const res = await fetchIns.json();

  ctx.body = res;
  ctx.next();
}

// 钩子侵入请求系统内部
export async function hookDone(ctx) {
  const hookDone = ctx?.options?.hookDone;

  hookDone && delete ctx.options.hookDone;

  await ctx.next();

  // 修改结果
  hookDone && hookDone.call(ctx, ctx.body, responseIsOk);
}

export async function handleException(ctx) {
  await ctx.next();
  // 在这里处理一些问题
  const { ret } = ctx.body || {};
  switch (ret) {
    case '3':
      loginStateExpiress();
      break;
    // 外网账号未关联内网账号导致登录异常
    case '-2':
      afterLoginFailed();
      break;
    // 无权限
    // case '4':
    //   message.error('暂无权限')
    //   break
    // // 后台异常
    // case '-6':
    //   message.error('网络异常，请稍后重试')
    //   break
    // // 操作频繁
    // case '-1':
    //   message.error('网络异常，请稍后重试')
    //   break
    // 正常
    case CODE_ISOK:
    case '0':
      break;
    default:
      // msg && message.error(msg)
      break;
  }
}

export async function handleError(ctx) {
  try {
    await ctx.next();
  } catch (ex) {
    // 只处理错误，
    // 将捕获的错误，处理完成后再抛出去
    ex.message && message.error(ex.message);
    console.error(ctx.body, ex);
  }
}
